import { Box, Flex, HStack, Link, Spinner, VStack } from "@chakra-ui/react";
import { AttachmentIcon } from "@chakra-ui/icons";
import CDS from "design-system";
import { AttachmentRow, formatBytes } from "features/Resources/Shared/attachments";

type Props = {
  items: AttachmentRow[];
  onRemove: (key: string) => void;
  disabled?: boolean;
};

export default function AttachmentsField({ items, onRemove, disabled = false }: Props) {
  if (items.length === 0) return null;

  return (
    <VStack align="stretch" spacing={2}>
      {items.map((item) => (
        <Flex
          key={item.key}
          align="center"
          justify="space-between"
          borderWidth="1px"
          borderColor={item.status === "error" ? "red.300" : "gray.200"}
          borderRadius="md"
          px={3}
          py={2}
          gap={3}
        >
          <HStack spacing={2} minW={0}>
            <AttachmentIcon color="fg.subtle" boxSize="14px" />
            <Box minW={0}>
              {item.url ? (
                <Link href={item.url} isExternal _hover={{ textDecoration: "underline" }}>
                  <CDS.Text14 noOfLines={1} color="cdsIndigo.500" textDecoration="underline">{item.filename}</CDS.Text14>
                </Link>
              ) : (
                <CDS.Text14 noOfLines={1} color="fg.default">{item.filename}</CDS.Text14>
              )}
              <CDS.Text12 color={item.status === "error" ? "red.500" : "fg.subtle"}>
                {item.status === "uploading"
                  ? `Uploading… ${item.progress}%`
                  : item.status === "error"
                    ? item.error || "Upload failed"
                    : formatBytes(item.byteSize)}
              </CDS.Text12>
            </Box>
          </HStack>
          <HStack spacing={1} flexShrink={0}>
            {item.status === "uploading" && <Spinner size="xs" color="fg.subtle" />}
            {!disabled && (
              <CDS.IconButton
                aria-label={`Remove ${item.filename}`}
                iconType="x"
                size="sm"
                variant="ghost"
                onClick={() => onRemove(item.key)}
              />
            )}
          </HStack>
        </Flex>
      ))}
    </VStack>
  );
}
